"use client";

import React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useSession } from 'next-auth/react'
import { navigationConfig } from '@/app/gestion/config/nav'

interface SidebarNavigationProps {
    puedeListarColecciones: boolean
    puedeListarCatalogos: boolean
    puedeListarDocumentos: boolean
}

interface SidebarSession {
    user?: {
        roles?: string[]
    }
}

export default function SidebarNavigation({
    puedeListarColecciones,
    puedeListarCatalogos,
    puedeListarDocumentos,
}: SidebarNavigationProps) {
    const pathname = usePathname()
    const { data: session } = useSession()

    // Extraer los roles guardados de forma segura en la sesión del servidor (v5)
    const userRoles = (session as SidebarSession | null)?.user?.roles ?? []

    return (
        <nav className="border-bottom" style={{ backgroundColor: '#043473' }} aria-label="Menú principal">
            <div className="d-flex flex-nowrap overflow-x-auto py-1 px-1">
                {navigationConfig.map((item, index) => {
                    if (item.name === 'Colecciones' && !puedeListarColecciones) {
                        return null
                    }
                    if (item.name === 'Catálogos' && !puedeListarCatalogos) {
                        return null
                    }
                    if (item.name === 'Documentos' && !puedeListarDocumentos) {
                        return null
                    }

                    // Validación de seguridad visual por roles
                    if (item.roles && !item.roles.some(role => userRoles.includes(role))) {
                        return null
                    }

                    const href = item.href.replace(/\/+$/, '') || '/'
                    const currentPath = pathname.replace(/\/+$/, '') || '/'
                    const isActive = currentPath === href
                        || (href !== '/gestion' && currentPath.startsWith(`${href}/`))

                    return (
                        <Link
                            key={index}
                            href={item.href}
                            aria-current={isActive ? 'page' : undefined}
                            className={`d-block flex-shrink-0 px-3 py-1 text-decoration-none ${
                                isActive
                                    ? 'border-white fw-semibold text-white'
                                    : 'border-transparent text-white'
                            }`}
                        >
                            {item.name}
                        </Link>
                    )
                })}
            </div>
        </nav>
    )
}
